(function(angular){
	'use strict';
	
	angular
		.module('baseCheckoutModule')
		.controller('SelectAccountType', [
			'globalConfig',
			SelectAccountTypeFunction
		]);
	
	function SelectAccountTypeFunction(
		globalConfig
	){
		var selectAccountType = this;

		selectAccountType.changeAccountType = function() {
			selectAccountType.formAction = selectAccountType.newAccountType.value;
		};

		selectAccountType.checkIfEligible = function(investmentEntityId) {
			if(investmentEntityId !== '-1')  {
				selectAccountType.showNewAccountTypes = false;
				selectAccountType.formAction = 'select-account';
				selectAccountType.previousSelectedRadio = selectAccountType.selectedRadio;
			} else {
				selectAccountType.showNewAccountTypes = true;
				selectAccountType.formAction = selectAccountType.newAccountType.value;
				selectAccountType.previousSelectedRadio = selectAccountType.selectedRadio;
			}
		};

		selectAccountType.$onInit = function() {
			selectAccountType.accountTypeOptions = [{
				label: 'Entity Account',
				value: 'new-entity-profile-form'
			}, {
				label: 'Joint Account',
				value: 'new-joint-account-profile-form'
			},{
				label: 'Trust Account',
				value: 'new-trust-profile-form'
			}];
			selectAccountType.newAccountType = selectAccountType.accountTypeOptions[0];
			selectAccountType.showNewAccountTypes = false;
			selectAccountType.formAction = 'select-account';
			selectAccountType.existingAccounts = globalConfig.existingAccounts;
			selectAccountType.selectedRadio = selectAccountType.existingAccounts[0].value;
			selectAccountType.previousSelectedRadio = selectAccountType.existingAccounts[0].value;
		};
	}
})(window.angular);